import { FC, useState } from 'react';
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Bell } from "lucide-react";

export const NotificationsForm: FC = () => {
  const [notifications, setNotifications] = useState(true);

  return (
    <div className="flex items-center justify-between rounded-lg border p-4">
      <div className="flex items-start space-x-4">
        <Bell className="h-5 w-5 text-muted-foreground mt-1" />
        <div className="space-y-0.5">
          <Label className="text-base">Notificaciones por WhatsApp</Label>
          <p className="text-sm text-muted-foreground">
            Recibe actualizaciones sobre el progreso del estudiante
          </p>
        </div>
      </div>
      <Switch
        checked={notifications}
        onCheckedChange={setNotifications}
      />
    </div>
  );
};